export default __webpack_public_path__ + "static/media/ALLERGEN_MOLLUSCE.2faed302.png";